import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import { login } from '../api/api';
import Footer from '../components/Footer';
import { Card, Button, Input } from '../components/ui';

export default function Login() {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login: authLogin } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await login(email, password);
      authLogin(data);
      if (data.organizationId) {
        navigate(`/org/${data.organizationId}/dashboard`);
      } else {
        navigate('/');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#f8fafc] dark:bg-slate-900">
      <div className="flex-1 flex items-center justify-center px-4 py-12">
        <div className="w-full max-w-md">
          <Card className="p-8">
            <h1 className="text-2xl font-bold text-center text-[#0ea5e9] mb-2">SecureCoop</h1>
            <p className="text-center text-[#475569] dark:text-slate-400 mb-8">{t.securityPlatform}</p>
            <h2 className="text-xl font-semibold text-[#0f172a] dark:text-slate-100 mb-6">{t.signIn}</h2>
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="bg-red-500/10 border border-red-500/30 text-red-600 dark:text-red-400 px-4 py-2 rounded-[10px] text-sm">{error}</div>
              )}
              <div>
                <label className="block text-sm font-medium text-[#475569] dark:text-slate-400 mb-1">{t.email}</label>
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-[#475569] dark:text-slate-400 mb-1">{t.password}</label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <Button type="submit" variant="primary" disabled={loading} loading={loading} className="w-full py-3">
                {loading ? t.signInProgress : t.signIn}
              </Button>
            </form>
            <p className="mt-6 text-center text-[#475569] dark:text-slate-400">
              {t.noAccount}{' '}
              <Link to="/register" className="text-[#0ea5e9] hover:text-[#0284c7] font-medium transition duration-200">
                {t.signUpLink}
              </Link>
            </p>
          </Card>
        </div>
      </div>
      <Footer />
    </div>
  );
}
